'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downLoad = exports.animate = exports.oneOf = exports.getImgType = exports.stringifyQuery = exports.getFileSize = exports.fomatFloat = exports.toggleClass = exports.removeClass = exports.addClass = exports.hasClass = exports.levelLinkage = exports.imagePath = exports.getMenuNameByRouter = exports.getMenuByRouter = exports.phoneNumber = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.timeFormat = timeFormat;
exports.secondToHour = secondToHour;
exports.isIE9 = isIE9;

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

var _router = require('@/router');

var _config = require('@/config');

var _axios = require('../config/interceptors/axios');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {reqFailCallback} from "../config/interceptors/axios";
/**
 * 时间戳转换
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * @param {Number} tamp 时间戳
 * @param {String} fmt 格式
 */
function timeFormat(tamp, fmt) {
  var d = new Date(tamp);
  fmt = fmt || 'yyyy-MM-dd';
  if (!d || !tamp) return '';
  var o = {
    'M+': d.getMonth() + 1, //月份
    'd+': d.getDate(), //日
    'h+': d.getHours() % 12 == 0 ? 12 : d.getHours() % 12, //小时
    'H+': d.getHours(), //小时
    'm+': d.getMinutes(), //分
    's+': d.getSeconds(), //秒
    'q+': Math.floor((d.getMonth() + 3) / 3), //季度
    'S': d.getMilliseconds() //毫秒
  };
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468' : '') + week[d.getDay() + '']);
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
}

function secondToHour(second) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hh:mm';

  var hour = parseInt(second / 3600);
  var minute = parseInt(second / 60) % 60;
  var secon = second % 60;
  switch (type) {
    case 'hh:mm:ss':
      return hour + ':' + minute + ':' + secon;
    default:
      return hour + ':' + minute + ':';
  }
}

/**
 * @constructor {Function} 手机号表单校验
 * 手机号校验更新到2018年10月，支持最新的166号段
 */
var phoneNumber = exports.phoneNumber = {
  validator: function validator(rule, value, resolve) {
    var reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-9])\d{8}$/;
    var valid = reg.test(value);
    if (valid) return resolve();
    resolve(new Error('手机号校验失败'));
  },

  trigger: 'blur'

  /**
   * @description 根据当前路由获取面包屑
   * @params {Array} menus 菜单列表
   * @params {String} name 当前路由name
   * @return {Array} routes 当前路由列表
   */
};var getMenuByRouter = exports.getMenuByRouter = function getMenuByRouter(menus, name) {
  var routes = [];
  //获取面包屑组件
  var crumbsList = sessionStorage.getItem('crumbsList');
  menus.some(function (menu) {
    if (menu.children && menu.children.length) {
      if (routes.length <= 1) routes.length = 0;else return routes;
      routes.push(menu);
      menu.children.some(function (childMenu) {
        if (name === childMenu.menuCode) {
          return routes.push(childMenu);
        }
      });
    }
  });
  if (routes.length <= 1) {
    crumbsList = crumbsList && JSON.parse(crumbsList);
    crumbsList && (routes = crumbsList);
  } else sessionStorage.removeItem('crumbsList');
  _store2.default.commit('CRUMBS_LIST', routes);
  return routes;
};
/**
 * @description 根据当前路由名称获取面包屑
 * @params {Array} menus 菜单列表
 * @params {String} name 当前路由name
 * @return {Array} routes 当前路由列表
 */
var getMenuNameByRouter = exports.getMenuNameByRouter = function getMenuNameByRouter() {
  var menuNames = {};
  return function (name) {
    if (menuNames[name]) return menuNames[name];
    var menuList = _router.routes[1].children;
    var eachName = function eachName(list) {
      list.some(function (item) {
        if (item.name === name) {
          return menuNames[name] = item.meta.title;
        }
        if (item.children && item.children.length) {
          eachName(item.children);
        }
      });
    };
    eachName(menuList);
    return menuNames[name];
  };
};
/**
 *[imagePath {Function} 全局图片路径处理函数 ]
 * @param {string} type 图片类型，根据类型判断返回默认图片
 * @param {string} 图片Id 没有则为空，返回对应类型默认图片
 * @returns {string} 返回合并后图片路径
 */
var imagePath = exports.imagePath = function imagePath(type, imgId, open) {
  if (!type) throw new Error('请输入图片类型');
  if (imgId) {
    if (open) return '../' + _config.prefixPath + 'api-file/portal/open/file/stream/' + imgId + '?origin=true';
    return '../' + _config.prefixPath + 'api-file/portal/file/stream/' + imgId + '?origin=true';
  }
  switch (type) {
    case 'course':
      return require('@/static/images/dx/loading-dx.png');
    case 'headImg':
      return require('@/static/images/user/header-3.png');
    case 'user':
      return require('@/static/images/user/header-3.png');
    case 'album':
      return '../../static/images/album-default.png';
    case 'zero':
      return require('@/static/images/zero.png');
  }
};
/**
 *[levelLinkage {Function} 联动关系处理方法 ]
 * @param {Array} arr 存放ref、isLink的数组
 * @param ref 组件的ref属性
 * @param isLink 是否需要上级的value作为本请求的参数, true不需要   false需要或不传
 * 需配合 data-dictionary组件使用
 */
var levelLinkage = exports.levelLinkage = function levelLinkage(arrs, obj) {
  var _this = this;

  arrs.forEach(function (item, index) {
    var ref = _this.$refs[item.ref];
    if (ref.alreadySelect) {
      var a = ref.alreadySelect;
      if (arrs[index + 1]) {
        _this.$refs[arrs[index + 1].ref].getDictionary(a);
      } else {
        return false;
      }
    }
    ref.$on('on-change', function (val) {
      onChange({
        val: val,
        index: index
      });
    });
  });
  var onChange = function onChange(_ref) {
    var val = _ref.val,
        index = _ref.index;

    var refNext = void 0;
    var isLink = void 0;
    if (arrs[index + 1]) {
      refNext = _this.$refs[arrs[index + 1].ref];
      isLink = arrs[index + 1].isLink;
      refNext.clearOption();
    } else {
      isLink = null;
      refNext = _this.$refs[arrs[index].ref];
    }
    if (val) {
      if (!isLink) {
        refNext.getDictionary(val, obj);
      } else {
        refNext.getDictionary();
      }
    }
  };
};
/**
 *[hasClass {Function} 判断当前dom是否拥有某class ]
 * @param {Object} obj 当前dom对象
 * @param {String} cls class名
 */
var hasClass = exports.hasClass = function hasClass(obj, cls) {
  return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
};
/**
 *[addClass {Function} 给当前dom对象添加类名 ]
 * @param {Object} obj 当前dom对象
 * @param {String} cls class名
 * 需配合hasClass方法使用
 */
var addClass = exports.addClass = function addClass(obj, cls) {
  if (!hasClass(obj, cls)) obj.className += ' ' + cls;
};
/**
 *[removeClass {Function} 删除当前dom对象的某个类名 ]
 * @param {Object} obj 当前dom对象
 * @param {String} cls class名
 * 需配合hasClass方法使用
 */
var removeClass = exports.removeClass = function removeClass(obj, cls) {
  if (hasClass(obj, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    obj.className = obj.className.replace(reg, ' ');
  }
};
/**
 *[toggleClass {Function} 切换当前dom的某个类名 ]
 * @param {Object} obj 当前dom对象
 * @param {String} cls class名
 * 需配合hasClass、addClass、removeClass方法使用
 */
var toggleClass = exports.toggleClass = function toggleClass(obj, cls) {
  if (hasClass(obj, cls)) {
    removeClass(obj, cls);
  } else {
    addClass(obj, cls);
  }
};
/**
 *[fomatFloat {Function} 浮点数取值 ]
 * @param {Number} src 要取的值
 * @param {Number} pos 取几位小数
 */
var fomatFloat = exports.fomatFloat = function fomatFloat(src, pos) {
  return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
};
/**
 *[getFileSize {Function} 转换文件大小 ]
 * @param {Number} size 要取的值
 * @param {Number} pos 取几位小数
 */
var getFileSize = exports.getFileSize = function getFileSize(size, pos) {
  var fileSizeByte = size || 0;
  var currentSize = 0;
  var currentDesc = '';
  if (fileSizeByte < 1048576) {
    currentSize = fomatFloat(fileSizeByte / 1024, pos);
    currentDesc = 'K';
  } else if (fileSizeByte == 1048576) {
    currentSize = '1';
    currentDesc = 'M';
  } else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) {
    currentSize = fomatFloat(fileSizeByte / (1024 * 1024), pos);
    currentDesc = 'M';
  } else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) {
    currentSize = '1';
    currentDesc = 'G';
  } else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) {
    currentSize = fomatFloat(fileSizeByte / (1024 * 1024 * 1024), pos);
    currentDesc = 'G';
  } else {
    currentSize = '1';
    currentDesc = 'T';
  }
  var sizeDesc = currentSize + currentDesc;
  return sizeDesc;
};
//query转换字符串
var stringifyQuery = exports.stringifyQuery = function stringifyQuery(obj) {
  function encode(str) {
    return encodeURI(str);
  }

  var res = obj ? (0, _keys2.default)(obj).map(function (key) {
    var val = obj[key];
    if (val === undefined) {
      return '';
    }
    return encode(key) + '=' + encode(val);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? '?' + res : '';
};
var getImgType = exports.getImgType = function getImgType(item) {
  var a = item.substring(item.lastIndexOf('.') + 1);
  var b = '';
  if (a == 'xlsx') {
    b = 'xls';
  } else if (a == 'jpg' || a == 'png' || a == 'gif' || a == 'jpeg') {
    b = 'img';
  } else if (a == 'docx') {
    b = 'doc';
  } else if (a == 'txt') {
    b = 'txt';
  } else if (a == 'pdf') {
    b = 'pdf';
  } else if (a == 'mp4') {
    b = 'mp4';
  } else if (a == 'mp3') {
    b = 'mp4';
  } else if (a == 'zip') {
    b = 'zip';
  } else {
    b = 'xml';
  }
  return b;
};
var oneOf = exports.oneOf = function oneOf(value, validList) {
  //逆向操作，复杂度由O(n)变成O(1)
  for (var i = validList.length; i >= 0; i--) {
    if (value === validList[i]) return true;
  }
  return false;
};

/**
 * IE动画的兼容
 */
var animate = exports.animate = function animate(start, end, ele, itemWidth) {
  if (!isIE9()) {
    return;
  }
  var current = start * parseInt(itemWidth);
  var time = setInterval(function () {
    var step = Math.abs(end - start) * parseInt(itemWidth) / 50;
    if (end > start) {
      current += step;
      ele.style['-ms-transform'] = 'translateX(-' + current + 'px)';
      if (current >= end * parseInt(itemWidth)) {
        clearInterval(time);
        ele.style['-ms-transform'] = 'translateX(-' + end * parseInt(itemWidth) + 'px)';
      }
    } else {
      current -= step;
      ele.style['-ms-transform'] = 'translateX(-' + current + 'px)';
      if (current <= end * parseInt(itemWidth)) {
        clearInterval(time);
        ele.style['-ms-transform'] = 'translateX(-' + end * parseInt(itemWidth) + 'px)';
      }
    }
  });
};

// IE9的判断
function isIE9() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9;

  var UA = window.navigator.userAgent.toLowerCase();
  // ie9 兼容性视图
  var compatibility = 7;
  var IEFlag = /trident/;
  var IE9Flag = /msie\s*(\d+)|rv:(\d+)/;
  if (!IEFlag.test(UA)) return false;
  var result = (UA || '').match(IE9Flag);
  result = ~~(result[1] || result[2]);
  return result === version || result === compatibility;
}

//接口工具下载
var downLoad = exports.downLoad = function downLoad() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fileName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var winMode = arguments[3];

  var params = (0, _keys2.default)(data).reduce(function (cur, next) {
    return cur += next + '=' + data[next] + '&';
  }, '?').slice(0, -1);
  var openPage = window.open;
  url = _config.prefixPath.slice(0, url.indexOf('/') === 0 ? -1 : _config.prefixPath.length) + url + params;
  // 优先支持H5下载
  if ('download' in HTMLAnchorElement.prototype) {
    var anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', fileName);
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    //DOM追加为异步，在下一次tick中获取，避免强制回流
    setTimeout(function () {
      anchor.click();
      document.body.removeChild(anchor);
      // blob协议下，我们需要手动释放会话
      if (winMode) {
        setTimeout(function () {
          window.URL.revokeObjectURL(anchor.href);
        }, 250);
      }
    }, 16);
    return;
  }
  //ajax下载
  var myBlob = window.Blob || window.MozBlob || window.WebKitBlob;
  var URL = window.URL || window.WebKitURL || window.MozURL;
  if (myBlob && URL) {
    return (0, _axios.axios)({
      url: url,
      method: 'GET',
      response: 'blob'
    }).then(function (_ref2) {
      var data = _ref2.data;

      var url = window.URL.createObjectURL(data);
      openPage(url);
      window.URL.revokeObjectURL(url);
    });
  }
  openPage(url);
};